export default {
  isLoading: false,
  isReady: false,
  user: {},
}
